import { useCallback } from 'react';
import StacksApp from '@zondax/ledger-stacks';

export function useVerifyMatchingLedgerStacksPublicKey() {
  // const account = useCurrentStacksAccount(); TODO: restore account

  return useCallback(
    async (stacksApp: StacksApp) => {
      //   if (!account) return;
      //   const { publicKey } = await requestPublicKeyForStxAccount(stacksApp)(account.index);
      //   if (publicKey.toString('hex') !== account.stxPublicKey) {
      //     throw new Error('Mismatching public keys');
      //   }
    },
    // [account]
    []
  );
}
